import { NgModule } from '@angular/core';
import { CustomTooltipDirective } from './tooltip-directive';

@NgModule({
  declarations: [CustomTooltipDirective],
  exports: [CustomTooltipDirective]
})

export class CustomTooltipModule {}
